import React from "react";
import { Helmet } from "react-helmet";

const medicalSpecialities = [
  { name: "General Surgery", image: "assets/images/specialities/general-surgery.jpg", description: "Expert surgical care for various conditions" },
  { name: "Internal Medicine", image: "assets/images/specialities/general-medicine.jpg", description: "Comprehensive internal medicine services" },
  { name: "Orthopedics", image: "assets/images/specialities/orthopedics.jpg", description: "Bone and joint care specialists" },
  { name: "Cardiology", image: "assets/images/specialities/cardiology.jpg", description: "Heart care and cardiac treatments" },
  { name: "Anaesthesiology", image: "assets/images/specialities/anaesthesiology.jpg", description: "Safe anesthesia services" },
  { name: "Critical Care", image: "assets/images/specialities/critical-care.jpg", description: "24/7 intensive care unit" },
  { name: "Dental", image: "assets/images/specialities/dental.jpg", description: "Complete dental care solutions" },
  { name: "Dermatology", image: "assets/images/specialities/dermatology.jpg", description: "Skin care and treatment" },
  { name: "Diabetology", image: "assets/images/specialities/diabetology.jpg", description: "Diabetes management and care" },
  { name: "Endocrinology", image: "assets/images/specialities/endocrinology.jpg", description: "Hormone and gland disorders" },
  { name: "ENT", image: "assets/images/specialities/ent.jpg", description: "Ear, nose and throat care" },
  { name: "Gastroenterology", image: "assets/images/specialities/gastroenterology.jpg", description: "Digestive system treatments" },
  { name: "Emergency Medicine", image: "assets/images/specialities/emergency-medicine.jpg", description: "24/7 emergency medical services" },
  { name: "Medical & Surgical Oncology", image: "assets/images/specialities/oncology.jpg", description: "Cancer care and treatment" },
  { name: "Nephrology & Dialysis", image: "assets/images/specialities/nephrology.jpg", description: "Kidney care and dialysis" },
  { name: "Neurology & Neurosurgery", image: "assets/images/specialities/neurology.jpg", description: "Brain and nervous system care" },
  { name: "Obstetrics & Gynecology", image: "assets/images/specialities/obstetrics.jpg", description: "Women's health and maternity care" },
  { name: "Physiotherapy & Rehabilitation", image: "assets/images/specialities/physiotherapy.jpg", description: "Rehabilitation services" },
  { name: "Plastic Surgery", image: "assets/images/specialities/plastic-surgery.jpg", description: "Reconstructive and cosmetic surgery" },
  { name: "Psychiatry", image: "assets/images/specialities/psychiatry.jpg", description: "Mental health services" },
  { name: "Urology", image: "assets/images/specialities/urology.jpg", description: "Urinary tract and male reproductive health" },
  { name: "Vascular Surgery", image: "assets/images/specialities/vascular.jpg", description: "Blood vessel treatments" },
  { name: "Respiratory Medicine", image: "assets/images/specialities/respiratory.jpg", description: "Lung and respiratory care" },
  { name: "Cosmetic Surgery", image: "assets/images/specialities/plastic-surgery.jpg", description: "Aesthetic procedures" },
];

const Specialities = () => {
  return (
    <section className="container my-5" aria-labelledby="Specialities-heading" style={{ overflowX: 'hidden' }}>
      <Helmet>
        <title>Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Medical Specialities</title>
        <meta name="description" content="Columbiaa Hospital, Kasturi Nagar, Bangalore offers 24+ medical specialities including cardiology, neurology, neurosurgery, orthopedics, oncology, nephrology, obstetrics and gynaecology. Best multi-speciality hospital in Bangalore with expert doctors and advanced treatments." />
        <meta name="keywords" content="Columbiaa Hospital, hospital in Kasturi Nagar, best multi-speciality hospital Bangalore, general surgery, internal medicine, orthopedics, orthopaedic hospital Bangalore, cardiology, cardiac hospital Bangalore, anaesthesiology, critical care, dental hospital, dermatologist Bangalore, diabetologist, endocrinologist, ENT hospital, gastroenterologist Bangalore, emergency medicine, oncology, cancer treatment Bangalore, nephrology, dialysis Bangalore, neurology, neurosurgery, neurosurgeon Bangalore, obstetrics, gynaecologist Bangalore, physiotherapy, plastic surgery, psychiatrist Bangalore, urologist Bangalore, vascular surgery, respiratory medicine, cosmetic surgery, hospital near me, 24/7 hospital Bangalore, multi-speciality hospital near Kasturi Nagar" />
        <meta name="author" content="Columbiaa Hospital" />
        <meta name="robots" content="index, follow" />
        <meta property="og:title" content="Columbiaa Hospital | Best Multi-Speciality Hospital in Kasturi Nagar Bangalore - Medical Specialities" />
        <meta property="og:description" content="Discover 24+ medical specialities at Columbiaa Hospital, Kasturi Nagar, Bangalore. Expert care in cardiology, neurology, orthopedics, oncology and more. Top multi-speciality hospital with state-of-the-art facilities." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://columbiaahospital.com/services" />
        <meta property="og:site_name" content="Columbiaa Hospital" />
        <meta property="og:locale" content="en_IN" />
        <link rel="canonical" href="https://columbiaahospital.com/services" />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "MedicalOrganization",
              "name": "Columbiaa Hospital",
              "url": "https://columbiaahospital.com",
              "logo": "https://columbiaahospital.com/assets/images/zclogo.png",
              "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-8548979899",
                "contactType": "appointments",
                "areaServed": "IN",
                "availableLanguage": ["English", "Hindi", "Kannada"]
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "Building No 06, 5th Main Rd, B Channasandra, OMBR Layout",
                "addressLocality": "Bengaluru",
                "addressRegion": "Karnataka",
                "postalCode": "560043",
                "addressCountry": "IN"
              },
              "sameAs": [
                "https://www.facebook.com/share/1BFLVsneD2/",
                "https://x.com/columbiaahosp",
                "https://www.linkedin.com/in/columbiaa-hospital-kasturi-nagar-bengaluru-98aa37323/",
                "https://www.instagram.com/columbiaahospital/",
                "https://www.youtube.com/@columbiaahospital"
              ]
            }
          `}
        </script>
      </Helmet>
      
      {/* Header */}
      <div className="text-center mb-4" data-aos="fade-right">
        <h1
          id="Specialities-heading"
          style={{ color: "#462b34", fontSize: "44px", fontWeight: "300" }}
          aria-label="Our Healthcare Specialities at Columbiaa Hospital, Kasturi Nagar, Bangalore"
        >
          Our Healthcare Specialities Designed for You at{" "}
          <strong>Columbiaa Hospital, Kasturi Nagar</strong>
        </h1>
        <p aria-label="Providing exceptional medical care and services to the residents of Kasturi Nagar">
          Providing exceptional medical care and services to the residents of Kasturi Nagar and surrounding areas.
        </p>
      </div>

      {/* Specialities Grid */}
      <div className="row">
        {medicalSpecialities.map((specialty, index) => (
          <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-3">
            <div
              className="d-flex align-items-center p-3 border shadow rounded bg-light"
              data-aos="fade-left"
              aria-label={`Speciality: ${specialty.name} at Columbiaa Hospital, Kasturi Nagar, Bangalore`}
              role="article"
            >
              <img
                src={specialty.image}
                alt={`${specialty.name} department at Columbiaa Hospital, Kasturi Nagar, Bangalore - ${specialty.description}`}
                title={`${specialty.name} - Columbiaa Hospital`}
                className="rounded-circle"
                style={{ width: "50px", height: "50px", objectFit: "cover", marginRight: "10px" }}
                data-aos="fade-down-right"
                loading="lazy"
              />
              <div>
                <h6 className="m-0" aria-label={`${specialty.name} department`}>{specialty.name}</h6>
                <p className="m-0 text-muted small" aria-hidden="true">{specialty.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Schema Markup for SEO */}
      <div
        itemScope
        itemType="https://schema.org/MedicalOrganization"
        aria-label="Columbiaa Hospital, Kasturi Nagar, Bangalore"
      >
        <meta itemProp="name" content="Columbiaa Hospital" />
        <meta itemProp="address" content="Kasturi Nagar, Bangalore, India" />
        <meta itemProp="telephone" content="+918044484444" />
        <meta itemProp="url" content="https://www.columbiaahospital.com" />
        <meta itemProp="logo" content="assets/images/logo.png" />
        <meta itemProp="description" content="Columbiaa Hospital, Kasturi Nagar offers a wide range of medical Specialities and healthcare services including cardiology, neurology, orthopedics, oncology, nephrology, and more." />
      </div>
    </section>
  );
};

export default Specialities;
